import React from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
} from "@chakra-ui/react";
import { User } from "../../types";
import { AccountProfileForm } from "../AccountProfileForm";
import { isMobile } from "react-device-detect";

type Props = {
  isOpen: boolean;
  user: User;
  isSubmitting: boolean;
  onSubmit: (data: any) => any;
};

export const UserCompleSignupModal: React.FC<Props> = observer(
  ({ isOpen, user, isSubmitting, onSubmit }) => {
    const { t } = useTranslation();

    return (
      <Modal
        isOpen={isOpen}
        onClose={() => null}
        size={isMobile ? "xs" : "2xl"}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{t("screens.signUp.completeSignup")}</ModalHeader>
          <ModalBody>
            <AccountProfileForm
              user={user}
              onSubmit={onSubmit}
              isSubmitting={isSubmitting}
            />
          </ModalBody>
        </ModalContent>
      </Modal>
    );
  }
);
